import { combineReducers } from "redux";
import {RESET_STORE} from '../ActionTypes'
import webAppReducer from "./webAppReducer";
import CampaignProspectReducer from "./CampaignProspectReducer";
import LoginReducer from "./LoginReducer";
import BulkUploadReducer from "./BulkUploadReducer"
import spinnerReducer from "./SpinnerReducer";
import KeyPerformanceReducer from "./KeyPerformanceReducer";
import calendarReducer from "./calendarReducer";
import UserManagementReducer from "./UserManagementReducer"
const appReducer = combineReducers({
  webApp: webAppReducer,
  campaignProspect:CampaignProspectReducer,
  spinner: spinnerReducer,
  export: KeyPerformanceReducer,
  login:LoginReducer,
  calendar:calendarReducer,
  bulk:BulkUploadReducer,
  user:UserManagementReducer
});

const rootReducer = (state, action) => {
  if(action.type===RESET_STORE){
    state=undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
